module.exports = __webpack_public_path__ + "static/media/1998_Population_totalRate.43bbb749.png";